import { render, staticRenderFns } from "./ReservationScheduleStatusSwitch.vue?vue&type=template&id=5d82d538&scoped=true&lang=pug"
import script from "./ReservationScheduleStatusSwitch.vue?vue&type=script&lang=ts"
export * from "./ReservationScheduleStatusSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ReservationScheduleStatusSwitch.vue?vue&type=style&index=0&id=5d82d538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82d538",
  null
  
)

export default component.exports